<template>
  <main class="flyers-page">
    <section class="hero">
      <div class="hero-content">
        <h1>Flyers & Print Materials</h1>
        <p>Download and print materials to help spread the word about Space Coast STEM</p>
      </div>
    </section>

    <section class="content-section">
      <div class="container">
        <div class="flyers-grid">
          <router-link to="/flyers/general" class="flyer-card">
            <div class="flyer-icon">🎓</div>
            <h3>General Information</h3>
            <p>For schools, guidance counselors, and social workers. Includes laptop request QR code and teacher signup info</p>
            <span class="view-button">View Flyer →</span>
          </router-link>

          <router-link to="/flyers/theplan" class="flyer-card">
            <div class="flyer-icon">📋</div>
            <h3>The Plan</h3>
            <p>Information about our bulk purchasing strategy and how we scale our impact</p>
            <span class="view-button">View Flyer →</span>
          </router-link>

          <router-link to="/flyers/it" class="flyer-card">
            <div class="flyer-icon">💼</div>
            <h3>IT Donation</h3>
            <p>Information for IT departments about donating equipment in bulk</p>
            <span class="view-button">View Flyer →</span>
          </router-link>

          <router-link to="/flyers/dropbox" class="flyer-card">
            <div class="flyer-icon">📦</div>
            <h3>Drop Box Location</h3>
            <p>Signage for laptop drop-off locations with QR code and contact info</p>
            <span class="view-button">View Flyer →</span>
          </router-link>
        </div>

        <div class="print-info">
          <h2>Printing Tips</h2>
          <ul>
            <li>All flyers are designed for standard 8.5" x 11" letter-size paper</li>
            <li>Use your browser's print function (Ctrl+P or Cmd+P) to print</li>
            <li>Select "Print backgrounds" or "Background graphics" for best results</li>
            <li>For professional results, consider printing on cardstock or laminating</li>
          </ul>
        </div>
      </div>
    </section>
  </main>
</template>

<script setup lang="ts">
// No special logic needed for this page
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700;800&family=Inter:wght@400;500;600&display=swap');

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.hero {
  background: linear-gradient(135deg, var(--primary-color, #2c4a6b) 0%, var(--secondary-color, #3ba3d1) 100%);
  color: var(--white, #ffffff);
  padding: 6rem 2rem;
  text-align: center;
}

.hero-content h1 {
  font-size: 3rem;
  margin-bottom: 1rem;
  font-weight: 700;
  font-family: 'Poppins', sans-serif;
}

.hero-content p {
  font-size: 1.3rem;
  opacity: 0.95;
}

.content-section {
  padding: 5rem 2rem;
}

.flyers-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  margin-bottom: 4rem;
}

.flyer-card {
  background: var(--white, #ffffff);
  border: 2px solid #e0e0e0;
  border-radius: 12px;
  padding: 2rem;
  text-align: center;
  text-decoration: none;
  color: inherit;
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.flyer-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
  border-color: var(--secondary-color, #3ba3d1);
}

.flyer-icon {
  font-size: 4rem;
  margin-bottom: 0.5rem;
}

.flyer-card h3 {
  font-family: 'Poppins', sans-serif;
  font-size: 1.5rem;
  color: var(--primary-color, #2c4a6b);
  margin: 0;
}

.flyer-card p {
  color: var(--text-light, #666666);
  line-height: 1.6;
  flex: 1;
  margin: 0;
}

.view-button {
  color: var(--secondary-color, #3ba3d1);
  font-weight: 600;
  font-size: 1.1rem;
  margin-top: 0.5rem;
}

.flyer-card:hover .view-button {
  color: var(--primary-color, #2c4a6b);
}

.print-info {
  background: var(--light-bg, #f5f7fa);
  padding: 2rem;
  border-radius: 12px;
  border-left: 5px solid var(--secondary-color, #3ba3d1);
}

.print-info h2 {
  font-family: 'Poppins', sans-serif;
  color: var(--primary-color, #2c4a6b);
  margin-top: 0;
  margin-bottom: 1rem;
}

.print-info ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.print-info li {
  padding: 0.5rem 0;
  padding-left: 2rem;
  position: relative;
  color: var(--text-light, #666666);
  line-height: 1.6;
}

.print-info li::before {
  content: "✓";
  position: absolute;
  left: 0;
  color: var(--secondary-color, #3ba3d1);
  font-weight: bold;
  font-size: 1.2rem;
}

@media (max-width: 768px) {
  .hero-content h1 {
    font-size: 2rem;
  }

  .hero {
    padding: 4rem 2rem;
  }

  .flyers-grid {
    grid-template-columns: 1fr;
  }
}
</style>
